import { READER_ROLE_FLAG } from '../config/runtimeConfig'

export const READER_ROLE_ENABLED = READER_ROLE_FLAG

export const READ_ONLY_MESSAGE = 'Your account has read-only access. You can view this page, but you cannot create, edit, delete, or change resources.'

export function isReadOnlyUser(user) {
  return READER_ROLE_ENABLED && user?.role === 'reader'
}

export function canReaderViewAdminPages(user) {
  return isReadOnlyUser(user)
}

export function isAdminOrReader(user) {
  return user?.role === 'admin' || isReadOnlyUser(user)
}

export function isTemplateManagerOrReader(user) {
  return user?.role === 'admin' || user?.role === 'template_manager' || isReadOnlyUser(user)
}

export function getReadOnlyDisabledProps(user) {
  if (!isReadOnlyUser(user)) return {}
  return {
    disabled: true,
    title: READ_ONLY_MESSAGE,
    'aria-disabled': true,
  }
}

export function guardReadOnly(user, notify) {
  if (!isReadOnlyUser(user)) return false
  if (notify) notify(READ_ONLY_MESSAGE)
  return true
}
